import { useMemo, useState } from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { Check, ChevronDown, Search } from 'lucide-react';

export function MultiSelect({ label, options, selected, onChange, allLabel = 'All', searchable = true }) {
  const [query, setQuery] = useState('');
  const visible = useMemo(() => options.filter(option => option.toLowerCase().includes(query.toLowerCase())), [options, query]);
  const summary = selected.length === 0 ? allLabel : selected.length === 1 ? selected[0] : `${selected.length} selected`;
  const toggle = option => onChange(selected.includes(option) ? selected.filter(item => item !== option) : [...selected, option]);

  return <DropdownMenu.Root onOpenChange={open => { if (!open) setQuery(''); }}>
    <DropdownMenu.Trigger className="shadcn-select-trigger" aria-label={label}>
      <span>{summary}</span><ChevronDown size={14} aria-hidden="true" />
    </DropdownMenu.Trigger>
    <DropdownMenu.Portal>
      <DropdownMenu.Content className="shadcn-select-content" sideOffset={5} align="start">
        {searchable && <div className="shadcn-select-search"><Search size={13} /><input value={query} onChange={event => setQuery(event.target.value)} placeholder={`Search ${label.toLowerCase()}`} onKeyDown={event => event.stopPropagation()} /></div>}
        <DropdownMenu.Item className="shadcn-select-action" onSelect={() => onChange([])}><Check className={selected.length === 0 ? '' : 'invisible'} size={13} />{allLabel}</DropdownMenu.Item>
        <DropdownMenu.Separator className="shadcn-select-separator" />
        <div className="shadcn-select-scroll">{visible.map(option => <DropdownMenu.CheckboxItem key={option} className="shadcn-select-item" checked={selected.includes(option)} onCheckedChange={() => toggle(option)} onSelect={event => event.preventDefault()}>
          <span className="shadcn-select-check">{selected.includes(option) && <Check size={13} />}</span><span>{option}</span>
        </DropdownMenu.CheckboxItem>)}{visible.length === 0 && <div className="shadcn-select-empty">No matches</div>}</div>
      </DropdownMenu.Content>
    </DropdownMenu.Portal>
  </DropdownMenu.Root>;
}
